import React, { useEffect, useState } from 'react';
import { Layout } from '@abyss/web/ui/Layout';
import { Heading } from '@abyss/web/ui/Heading';
import { styled } from '@abyss/web/tools/styled';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Drawer } from '@abyss/web/ui/Drawer';
import { SubNavigationMenu } from '@abyss/web/ui/SubNavigationMenu';
import { V2FormProvider } from '@abyss/web/ui/FormProvider';
import { V2TextInput } from '@abyss/web/ui/TextInput';
import { LeftMenuController } from './LeftMenu.Controller';
import { MenuStyles } from './styles';

const StyledStackLayout = styled(Layout.Stack, {
  '@screen >= $xs': {
    paddingTop: '250px',
  },
  '@screen >= $sm': {
    paddingTop: '210px',
  },
  '@screen >= $md': {
    paddingTop: '210px',
  },
  paddingTop: '10%',
});

const StyledIcon = styled(IconMaterial, {
  cursor: 'pointer',
});

const StyledDrawer = styled(Drawer, {
  '.abyss-modal-body': { marginLeft: 0 },
  '.abyss-modal-close-button': { maxWidth: '32px!important' },
  '.abyss-modal-close-icon': { marginLeft: 0 },
  '@screen >= $xs': {
    marginLeft: '73px',
    '.abyss-modal-content-container': {
      minHeight: '123vh',
      overflowY: 'auto',
    },
  },
  '@screen >= $sm': {
    marginLeft: '73px',
    '.abyss-modal-content-container': {
      minHeight: '112vh',
      overflowY: 'auto',
    },
  },
  '@screen >= $lg': {
    marginLeft: '50px',
    '.abyss-modal-content-container': {
      minHeight: '100vh',
      overflowY: 'auto',
    },
  },
});

export const LeftMenu = () => {
  const {
    menuItems,
    form,
    Action,
    navItems,
    setNavItems,
    expandedMenuItems,
    setExpandedMenuItems,
    saveMenuState,
  } = LeftMenuController();

  // Only show Home and Dashboard icons for boilerplate
  return (
    <React.Fragment>
      <StyledStackLayout>
        <StyledIcon icon="home_work" size="25px" color="$primary1" />
        <StyledIcon
          icon="storage"
          onClick={Action.ShowMenu}
          size="25px"
          color="$primary1"
        />
      </StyledStackLayout>
      <StyledDrawer data-testid="nav-menu" position="left" model="menu-drawer">
        <Drawer.Section>
          <Heading
            data-testid="heading-root"
            textAlign="left"
            display="h5"
            css={MenuStyles.Heading}
          >
            Menu
          </Heading>
          <V2FormProvider state={form} onSubmit={() => Action.SearchMenu()}>
            <V2TextInput
              label="Search"
              type="search"
              placeholder="Search menu..."
              model="search"
              width="100%"
              isClearable
              onChange={(e: any) => Action.SearchMenu(e?.target?.value ?? '')}
              onClear={Action.SearchMenu}
              data-testid="menu-searchbar"
            />
          </V2FormProvider>
          <SubNavigationMenu
            navItems={navItems}
            position="right"
            onClick={Action.OnLinkClick}
            css={MenuStyles.SubNavigationMenu}
            data-testid="tree"
          />
        </Drawer.Section>
      </StyledDrawer>
    </React.Fragment>
  );
};
